import styled from 'styled-components'
import { Loading } from '@maui/elements'

export default styled.div`
  padding: 16px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  ${({ theme }) => theme.widget.content}

  // sets desktop dashboard min height
  @media only screen and (min-width: 768px) {
    min-height: auto;
  }

  > ${Loading} {
    // Expand to fill the content space.
    flex: 1;

    // Moves the loading icon up just a bit to compensate for whitespace
    // added from the header which makes it appear off center
    transform: translateY(-0.5em);
  }
`
